export const SaleStatus = {
	NONE: { id: 1, name: "Anulado" },
	NOT_AUTHORIZED: { id: 2, name: "Não Autorizado" },
	PRE_AUTHORIZED: { id: 3, name: "Pré-autorizado" },
	AUTHORIZED: { id: 4, name: "Pago" },
	PENDING: { id: 5, name: "Pendente" },
	CANCELED: { id: 6, name: "Cancelado" },
	REFUNDED: { id: 7, name: "Estornado" },
};



// WEBPACK FOOTER //
// ./src/enums/SaleStatus.js